import {Box, Button, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {AlertInfo} from 'presentation/components';

import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';
import {translations} from 'presentation/translations-new';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {useEmptyAppointmentsCard} from './hooks/useEmptyAppointmentsCard';
import {StyledCard} from './styles';
import {Loading} from 'presentation/components/Loading/Loading';

const {call, contactOnline} = translations['pt-br'].commons;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;
const {
	selfNetwork: {title},
	emptyAppointmentsCard,
} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function EmptyAppointmentsCard() {
	const {
		isMobile,
		anchorEl,
		openPhoneDrawerState,
		isPhoneNumberMenuOpen,
		handleOpenPhoneMenu,
		handleTogglePhoneDrawer,
		handleClosePhoneMenu,
		handleCallChatRoom,
		phoneNumbers,
		phoneNumbersAlert,
		callChatRoomIsLoading,
	} = useEmptyAppointmentsCard();

	return (
		<Fragment>
			<Stack gap={1}>
				<Typography variant="subtitle1" color="text.secondary" fontWeight={600}>
					{title}
				</Typography>

				<StyledCard elevation={0}>
					<Stack gap={2}>
						<Stack gap={0.5}>
							<Typography variant="h6">{emptyAppointmentsCard.cardTitle}</Typography>
							<Typography variant="body1" color="text.primary">
								{emptyAppointmentsCard.cardDescription}
							</Typography>
						</Stack>
						<Stack gap={1}>
							<Button
								variant={'contained'}
								size="large"
								data-tag-id={
									AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO
								}
								onClick={handleCallChatRoom}
								disabled={callChatRoomIsLoading}
								endIcon={
									callChatRoomIsLoading ? (
										<Loading size={16} color="inherit" />
									) : null
								}>
								{contactOnline}
							</Button>
							<Button
								variant={'outlined'}
								size="large"
								data-tag-id={AppointmentBookingEnum.CLICK_LIGAR_AGENDAMENTO}
								onClick={handleOpenPhoneMenu}>
								{call}
							</Button>
						</Stack>
					</Stack>
				</StyledCard>
			</Stack>

			{isMobile ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>

					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesDrawer.Root>
			) : (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<Box pb={2}>
						<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					</Box>

					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesMenu.Root>
			)}
		</Fragment>
	);
}
